import { render, staticRenderFns } from "./PPDCSDevice.vue?vue&type=template&id=5ac8df42&scoped=true&"
import script from "./PPDCSDevice.vue?vue&type=script&lang=js&"
export * from "./PPDCSDevice.vue?vue&type=script&lang=js&"
import style0 from "./PPDCSDevice.vue?vue&type=style&index=0&id=5ac8df42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac8df42",
  null
  
)

export default component.exports